import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Colour } from 'src/app/models/domain';
import { ColourAdapter } from 'src/app/models/domain/adapters';
import { YPMMULTICOLOURVService } from 'src/generated-clients/multicolour';

interface IMultiColourWrapper {
  materialId?: string;
  colour?: Colour;
}

@Injectable({
  providedIn: 'root',
})
export class MultiColourDataService {
  public constructor(
    private readonly multiColourService: YPMMULTICOLOURVService,
    private readonly colourAdapter: ColourAdapter
  ) {}

  public getMultiColoursByMaterialIds(materialIds: string[]): Observable<IMultiColourWrapper[]> {
    const mulitColourFilter = materialIds.map((id) => `materialId eq '${id}'`).join(' or ');

    return this.multiColourService
      .yPMMULTICOLOURVGet(
        undefined,
        undefined,
        mulitColourFilter,
        undefined,
        undefined,
        undefined,
        ['to_Colour']
      )
      .pipe(
        rethrowAsSapError(),
        map((result) => {
          if (!result.d?.results) {
            throw new Error('SAP Error');
          }

          return result.d.results.map((multiColourWrapper): IMultiColourWrapper => {
            return {
              colour: multiColourWrapper.to_Colour
                ? this.colourAdapter.adaptToDomain(multiColourWrapper.to_Colour)
                : undefined,
              materialId: multiColourWrapper.materialId,
            };
          });
        })
      );
  }
}
